import { useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { toast } from "sonner";
import { TrendingUp, Users, Handshake, BarChart3, CheckCircle, Send } from "lucide-react";
import { API } from "../config";

const FranchisePage = () => {
  const [formData, setFormData] = useState({ name: "", email: "", phone: "", city: "", investment_range: "", experience: "", message: "" });
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault(); setLoading(true);
    try { await axios.post(`${API}/franchise/inquiry`, formData); setSubmitted(true); toast.success("¡Solicitud enviada!"); }
    catch (error) { toast.error("Error al enviar."); } finally { setLoading(false); }
  };

  const benefits = [
    { icon: TrendingUp, title: "Modelo Probado", desc: "Más de 20 años de éxito" },
    { icon: Users, title: "Capacitación", desc: "Entrenamiento completo" },
    { icon: Handshake, title: "Soporte Continuo", desc: "Acompañamiento permanente" },
    { icon: BarChart3, title: "Rentabilidad", desc: "ROI en menos de 2 años" },
  ];

  return (
    <div className="min-h-screen pt-24 pb-16 bg-[#FAF9F6]" data-testid="franchise-page">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <span className="font-mono text-xs font-bold text-[#F57C00] tracking-[0.2em] uppercase">FRANQUICIAS ZIP'N GO</span>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-black text-[#5D4037] mt-4 leading-tight">Sé tu propio jefe con una franquicia exitosa</h1>
            <p className="text-stone-600 text-lg mt-6">Desde el año 2000 nos constituimos como una exitosa red de franquicias.</p>
            <div className="grid grid-cols-2 gap-6 mt-8">
              {benefits.map((b, i) => (
                <div key={i} className="flex items-start gap-3">
                  <div className="w-10 h-10 bg-[#2E7D32]/10 rounded-xl flex items-center justify-center flex-shrink-0"><b.icon size={20} className="text-[#2E7D32]" /></div>
                  <div><p className="font-bold text-[#5D4037]">{b.title}</p><p className="text-sm text-stone-500">{b.desc}</p></div>
                </div>
              ))}
            </div>
          </div>
          <div><img src="https://images.pexels.com/photos/4487484/pexels-photo-4487484.jpeg?auto=compress&cs=tinysrgb&w=600" alt="Franquicias" className="rounded-3xl shadow-xl" /></div>
        </div>
        <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="max-w-2xl mx-auto bento-card p-8 md:p-12">
          <h2 className="text-2xl font-bold text-[#5D4037] mb-2">Solicita información</h2>
          {submitted ? (
            <div className="text-center py-12" data-testid="franchise-success"><CheckCircle size={64} className="text-[#4CAF50] mx-auto mb-4" /><h3 className="text-xl font-bold text-[#5D4037]">¡Solicitud recibida!</h3></div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-6 mt-6">
              <div className="grid md:grid-cols-2 gap-6">
                <div><label className="block text-sm font-semibold text-[#5D4037] mb-2">Nombre *</label><input type="text" data-testid="franchise-name-input" value={formData.name} onChange={(e) => setFormData({...formData, name: e.target.value})} className="w-full h-14 px-4 rounded-xl border border-stone-200 focus:border-[#2E7D32] outline-none" required /></div>
                <div><label className="block text-sm font-semibold text-[#5D4037] mb-2">Email *</label><input type="email" data-testid="franchise-email-input" value={formData.email} onChange={(e) => setFormData({...formData, email: e.target.value})} className="w-full h-14 px-4 rounded-xl border border-stone-200 focus:border-[#2E7D32] outline-none" required /></div>
              </div>
              <div className="grid md:grid-cols-2 gap-6">
                <div><label className="block text-sm font-semibold text-[#5D4037] mb-2">Teléfono *</label><input type="tel" data-testid="franchise-phone-input" value={formData.phone} onChange={(e) => setFormData({...formData, phone: e.target.value})} className="w-full h-14 px-4 rounded-xl border border-stone-200 focus:border-[#2E7D32] outline-none" required /></div>
                <div><label className="block text-sm font-semibold text-[#5D4037] mb-2">Ciudad *</label><input type="text" data-testid="franchise-city-input" value={formData.city} onChange={(e) => setFormData({...formData, city: e.target.value})} className="w-full h-14 px-4 rounded-xl border border-stone-200 focus:border-[#2E7D32] outline-none" required /></div>
              </div>
              <div><label className="block text-sm font-semibold text-[#5D4037] mb-2">Inversión *</label><select data-testid="franchise-investment-select" value={formData.investment_range} onChange={(e) => setFormData({...formData, investment_range: e.target.value})} className="w-full h-14 px-4 rounded-xl border border-stone-200 outline-none bg-white" required><option value="">Selecciona</option><option value="200k-500k">$200K - $500K</option><option value="500k-1m">$500K - $1M</option><option value="1m+">Más de $1M</option></select></div>
              <button type="submit" data-testid="franchise-submit-btn" disabled={loading} className="w-full btn-primary h-14 flex items-center justify-center gap-2">
                {loading ? "Enviando..." : <><Send size={20} /> Enviar Solicitud</>}
              </button>
            </form>
          )}
        </motion.div>
      </div>
    </div>
  );
};

export default FranchisePage;
